import gql from 'not-graphql-tag';

export const getOutageLookupQuery = gql`
  query getOutageLookup($params: OutageLookupParams!) {
    getOutageLookup(params: $params) {
      isAccountExists
      isEligibleToReport
      outageStatusWarnings {
        showConnectionInfo
        showResetInfo
      }
      outages {
        encryptedServicePointId
        totalReports
        crewDispatchStatus
        estimatedTimeOn
        estimatedTimeOut
        hasKnownOutage
        isDueToStorm
        customersAffected
        cause
        isReported
        eventStatus
      }
      encryptedAccountNumber
      encryptedPremiseId
      houseNumber
      multiplePremiseList {
        encryptedValue
        houseNumber
        last4CharAddress
      }
    }
  }
`;
